import { useEffect } from 'react';
import { KO } from '../data/constants';

function translateKorean(text: string): string {
  const trimmed = text.trim();
  if (!trimmed) return text;
  if (KO[trimmed]) return text.replace(trimmed, KO[trimmed]);
  let value = trimmed
    .replace(/^(\d+) songs$/, '$1곡')
    .replace(/^(\d+) stages$/, '$1단계')
    .replace(/^Start (Easy|Normal|Hard) Stage$/, (_, level) => `${KO[level]} 스테이지 시작`)
    .replace(/^Choose (.+)$/, (_, plan) => `${KO[plan] || plan} 선택`)
    .replace(/^Back to (.+)$/, (_, page) => `${KO[page] || page}로 돌아가기`)
    .replace(/(Easy|Normal|Hard)/g, (level) => KO[level])
    .replace(/(Color Drum|Color Staff|Classic Staff)/g, (format) => KO[format]);
  Object.entries(KO).filter(([key]) => ['Electronic', 'Kids', 'Pop', 'World', 'Rock', 'Jazz', 'Latin'].includes(key)).forEach(([key, translated]) => {
    value = value.replace(new RegExp(`\\b${key}\\b`, 'g'), translated);
  });
  return text.replace(trimmed, value);
}

export function useKoreanDom(language: string, changeKey: string) {
  useEffect(() => {
    const root = document.querySelector('[data-localized-root]');
    if (!root || language !== 'ko') return undefined;
    const translate = () => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      const nodes: Node[] = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach((node) => {
        const next = translateKorean(node.nodeValue || '');
        if (next !== node.nodeValue) node.nodeValue = next;
      });
      root.querySelectorAll<HTMLInputElement>('input[placeholder]').forEach((input) => {
        input.placeholder = translateKorean(input.placeholder);
      });
    };
    translate();
    const observer = new MutationObserver(translate);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    return () => observer.disconnect();
  }, [language, changeKey]);
}
